import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Checkbox,
} from '@mui/material';
import { useState } from 'react';
import RouteMessage from '../../components/RouteMessage/RouteMessage';

export default function ForceCloseModal({
  isOpen,
  handleClose,
  handleSubmit,
  message,
  allowForce,
  isSuccessful,
}) {
  const [checkbox, setCheckbox] = useState(false);

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xl">
      <DialogTitle variant="h3" fontWeight="bold">
        Close Route
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <RouteMessage message={message} />
        {allowForce && (
          <span style={{ marginBottom: '-1em' }}>
            <Checkbox
              checked={checkbox}
              onClick={(e) => {
                setCheckbox(e.target.checked);
              }}
              color="error"
              sx={{ mt: -0.5 }}
            />
            <Typography
              component="span"
              color="error"
              onClick={() => setCheckbox(!checkbox)}
              sx={{ cursor: 'pointer', userSelect: 'none' }}
            >
              Acknowledge error(s) and try to force route to close
            </Typography>
          </span>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          {isSuccessful ? 'Okay' : 'Cancel'}
        </Button>
        {allowForce && (
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={!checkbox}
            color="error"
          >
            Force Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
